import { createTheme, ThemeProvider, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import TextField from "@mui/material/TextField";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { CATEGORY_URL } from "../../Constants/Constants";
import AxiosInstance from "../../services/AxiosInstance";
import { useAlert } from "./../alerts/AlertContext";
import AddTaskIcon from "@mui/icons-material/AddTask";
import SaveIcon from "@mui/icons-material/Save";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { isEmpty } from "../../Constants/RolesConstants";

function CategoryDialog({
  categoryId,
  selectedCategoryName,
  callCategories,
  componentPermissions,
  actionType,
  isEdit
}) {
  const globaltheme = useTheme();
  const theme = createTheme({
    ...globaltheme,
    components: {
      MuiSelect: {},
    },
  });

  const showAlert = useAlert();
  const [open, setOpen] = React.useState(false);
  const [categoryName, setCategoryName] = useState("");
  const [desc, setDesc] = useState("");
  const [active, setActive] = useState("true");

  const handleClickOpen = () => {

    if (isEdit) {
      getCategory();
    } else {
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCategoryNameChange = (event) => {
    setCategoryName(event.target.value);
  };

  const handleStatusChange = (event) => {
    setActive(event.target.value);
  };

  const handleDescriptionChange = (event) => {
    setDesc(event.target.value);
  };

  const getCategory = async () => {
    await AxiosInstance.get(`${CATEGORY_URL}/${categoryId}`).then((response) => {
      var categoryData = response.data.data;
      setCategoryName(categoryData.name);
      setDesc(categoryData.description);
      setActive(categoryData.active);
      setOpen(true);
    });
  };

  const handleSave = () => {
    const payload = {};
    payload.name = categoryName;
    payload.description = desc;
    payload.active = active;
    if (isEdit) {
      updateCategory(payload);
    } else {
      saveCategory(payload);
    }
  };

  const saveCategory = async (payload) => {
    await AxiosInstance.post(CATEGORY_URL, payload)
      .then((response) => {
        showAlert("Category created successfully!", "success");
        callCategories();
      })
      .catch((error) => {
        showAlert("Category creation failed!", "error");
        console.error(error);
      });
  };

  const updateCategory = async (payload) => {
    await AxiosInstance.put(`${CATEGORY_URL}/${categoryId}`, payload)
      .then((response) => {
        showAlert("Category updated successfully!", "success");
        callCategories();
      })
      .catch((error) => {
        showAlert("Category updation failed!", "error");
        console.error(error);
      });
  };

  const saveButtonSx = {
    float: "right",
    minWidth: 150,
    marginRight: "25px",
    marginTop: "10px",
    background: "linear-gradient(45deg, #1976d2 30%, #42a5f5 90%)",
    boxShadow: "0 3px 5px 2px rgba(25, 118, 210, .3)",
    "&:hover": {
      background: "linear-gradient(45deg, #1565c0 30%, #1976d2 90%)",
    },
  };

  return (
    <ThemeProvider theme={theme}>
      <React.Fragment>
        {isEdit === false ? (
          <>          
          < Tooltip
            title="Add Category"
            onClick={handleClickOpen}
            style={{
              cursor: "pointer",
              margin: "5px 0px",
              float: "right",
            }}
          >
            <IconButton>
              <AddTaskIcon color="primary" />
            </IconButton>
          </Tooltip>
          </>
  ) : (
    <Link onClick={handleClickOpen}>{selectedCategoryName}</Link>
        )
}

<Dialog
          open={open}
          onClose={handleClose}
          PaperProps={{
            component: "form",
            onSubmit: (event) => {
              event.preventDefault();
              (isEmpty(componentPermissions) ||
                componentPermissions ?.["canUpdate"] ||
                  componentPermissions ?.["canCreate"]) &&
                handleSave();
              handleClose();
            },
            sx: {
              width: 600,
              height: 460,
              maxWidth: "100%",
              maxHeight: "100%",
            },
          }}
        >
          <DialogTitle>{actionType} Category</DialogTitle>
          <DialogContent>
            <Box
              component="form"
              noValidate
              autoComplete="off"
              sx={{ "& .MuiTextField-root": { m: 1, width: "95%" } }}
            >
              <TextField
                autoFocus
                required
                margin="dense"
                id="rg"
                name="name"
                label="Category Name"
                type="text"
                fullWidth
                variant="outlined"
                value={categoryName}
                onChange={handleCategoryNameChange}
              />
              <TextField
                autoFocus
                id="outlined-multiline-static"
                name="description"
                label="Description"
                placeholder="Enter Description"
                fullWidth
                multiline
                rows={4}
                cols={10}
                value={desc}
                onChange={handleDescriptionChange}
              />
              <FormControl sx={{ m: 2, minWidth: "47%" }}>
                <FormLabel id="demo-row-radio-buttons-group-label">
                  Active
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={active}
                  onChange={handleStatusChange}
                >
                  <FormControlLabel
                    value={true}
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
            </Box>
          </DialogContent>
          <DialogActions sx={{ marginBottom: "20px" }}>
            {actionType === "Add" ? (
              <Button
                variant="contained"
                type="submit"
                startIcon={<SaveIcon />}
                sx={saveButtonSx}
              >
                Save
              </Button>
            ) : null}
            {actionType === "Edit" &&
            (isEmpty(componentPermissions) ||
              componentPermissions ?.["canUpdate"]) ? (
              <Button
                variant="contained"
                type="submit"
                startIcon={<SaveIcon />}
                sx={saveButtonSx}
              >
                Save
              </Button>
            ) : null}
          </DialogActions>
        </Dialog>
      </React.Fragment >
    </ThemeProvider >
  );
}
export default CategoryDialog;
